/**
 * A wait in plain words for a rate-limit answer's `retryAfter` seconds: "20
 * seconds", "about 12 minutes", "about 3 hours" — a daily cap's 86,400 seconds
 * must not read as "Please wait 86400 seconds" (R92-L13).
 *
 * @param seconds - The seconds to wait.
 * @returns The phrase.
 */
export function waitPhrase(seconds: number): string {
  const s = Math.max(1, Math.round(seconds))
  if (s < 90) return `${s} second${s === 1 ? '' : 's'}`
  const minutes = Math.round(s / 60)
  if (minutes < 90) return `about ${minutes} minutes`
  const hours = Math.round(s / 3600)
  if (hours < 36) return `about ${hours} hour${hours === 1 ? '' : 's'}`
  return `about ${Math.round(s / 86_400)} days`
}
